document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-copy-product-name]');
  if (!btn) return;

  var title = btn.getAttribute('data-product-title') || '';
  var label = btn.querySelector('[data-copy-product-name-label]');
  var originalText = label ? label.textContent : '';

  var showCopied = function () {
    if (!label) return;
    label.textContent = 'Copied!';
    setTimeout(function () {
      label.textContent = originalText;
    }, 1800);
  };

  var fallbackCopy = function () {
    var textarea = document.createElement('textarea');
    textarea.value = title;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showCopied();
    } catch (err) {
      /* no-op: copy failed, nothing further to do */
    }
    document.body.removeChild(textarea);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(title).then(showCopied, fallbackCopy);
  } else {
    fallbackCopy();
  }
});
